import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Crisis financiera',
    sin: 'Decisiones impulsivas por miedo',
    con: 'Protocolo de Vacío + Matriz de Decisión activos'
  }, {
    sit: 'Conflicto familiar',
    sin: 'Reacciones que se lamentan después',
    con: 'Scripts de Blindaje Verbal para mantener la autoridad'
  }, {
    sit: 'Presión de negocio',
    sin: 'Parálisis o escalada sin control',
    con: 'Arquitectura de Decisión Bajo Fuego en 10 minutos'
  }, {
    sit: 'Noticia impactante',
    sin: 'Narrativa catastrófica automática',
    con: 'Filtro de Neutralidad para separar hechos de miedo'
  }, {
    sit: 'Confrontación pública',
    sin: 'Bloqueo verbal y pérdida de autoridad',
    con: '5 protocolos verbales para cualquier situación'
  }];
  const modules = [{
    icon: '🧠',
    title: 'Sección 1 — El Protocolo de Vacío',
    desc: 'El reseteo cognitivo de 120 segundos para bajar el cortisol y volver a pensar con claridad cuando la presión intenta apagar la corteza prefrontal. Cinco pasos. Dos minutos. Siempre disponible.'
  }, {
    icon: '⚙️',
    title: 'Sección 2 — Arquitectura de Decisión Bajo Fuego',
    desc: 'La Matriz de 3 Columnas para tomar decisiones de calidad en situaciones de urgencia real. Nunca más decisiones apresuradas por el miedo ni parálisis por la magnitud del problema.'
  }, {
    icon: '🔍',
    title: 'Sección 3 — El Filtro de Neutralidad',
    desc: 'Las 4 preguntas para separar hechos de interpretaciones en tiempo real. Cómo detectar y desactivar la narrativa catastrófica antes de que contamine tu respuesta.'
  }, {
    icon: '🗣️',
    title: 'Sección 4 — Blindaje Verbal en Conflictos',
    desc: 'Los 5 protocolos de comunicación para mantener la autoridad y la claridad en discusiones de alta tensión. Con familia, con socios, con clientes, con cualquiera.'
  }, {
    icon: '🛡️',
    title: 'Arsenal — Herramientas de Campo',
    desc: 'Tarjetas de emergencia para llevar siempre. Matriz de Riesgo Crítico. Checklist del Día Después. Plan de 72 horas post-crisis. Todo listo para usar cuando lo necesitás.'
  }];
  return <section className="py-10 px-4 bg-dark-card/30 pt-[15px] pb-[15px]" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="text-center mb-6" data-id="element-31">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-32">
            🚀 ¿QUÉ AGREGA EL MÉTODO BLINDAJE™?
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto" data-id="element-33">
            Para el hombre que ya entrena su mente en calma y ahora quiere que
            funcione igual cuando todo a su alrededor se descontrola.
          </p>
        </div>

        <div className="space-y-2 mb-8" data-id="element-34">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark-card border border-dark-border rounded-xl p-3 grid grid-cols-3 gap-2 items-center" data-id="element-35">
              <div className="font-bold text-white text-sm" data-id="element-36">{row.sit}</div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-37">
                <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" data-id="element-38" />
                <span className="text-gray-400" data-id="element-39">{row.sin}</span>
              </div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-40">
                <Check className="w-3.5 h-3.5 text-brand flex-shrink-0" data-id="element-41" />
                <span className="text-white font-medium" data-id="element-42">{row.con}</span>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-4" data-id="element-43">
          <h3 className="text-lg font-black text-white" data-id="element-44">
            ✅ MÉTODO BLINDAJE™ INCLUYE 5 SECCIONES:
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-45">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark border border-dark-border p-3 rounded-xl flex items-start space-x-2" data-id="element-46">
              <span className="text-lg" data-id="element-47">{mod.icon}</span>
              <div data-id="element-48">
                <h4 className="font-bold text-brand text-xs" data-id="element-49">{mod.title}</h4>
                <p className="text-gray-400 text-xs" data-id="element-50">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center" data-id="element-51">
          <p className="text-gray-300 italic text-sm max-w-xl mx-auto leading-relaxed" data-id="element-52">
            "Si los 4 Tomos te entrenaron para rendir bien cuando todo está
            tranquilo, el Método Blindaje te entrena para rendir bien cuando
            todo explota. Eso es lo que separa a un hombre que manda de uno que
            reacciona."
          </p>
        </motion.div>
      </div>
    </section>;
}